export default __webpack_public_path__ + "static/media/Veralyn-Williams.02b401e9.png";